import React from 'react';
import { Icon } from 'semantic-ui-react'

const ArrowIcon = (props) => <Icon name='angle double up' color='red' size='large' {...props}/>

export default React.forwardRef(ArrowIcon);
